import React from "react"
import styled from "styled-components"

import media from "../../../styles/media"
import { RosterNavButton } from "./RosterNav"
import { AllButton, SubcategoryButtons } from "./RosterFilterMenu"
import {
  useRosterCategoryState,
  useRosterCategoryDispatch,
  rosterCategoryActions,
} from "../../context/RosterCategoryContext"

const List = styled.ul`
  display: flex;
  overflow-x: auto;
  list-style: none;
  padding: 0 0 1em 0;
  font-family: StanleyRegular, serif;

  li {
    white-space: nowrap;
    margin-right: 1em;
  }

  ${media.tablet`
    display: none;
  `}
`

export function MobileRosterFilterMenu({ publicCategories }) {
  const { selectedCategory, selectedSubcategories } = useRosterCategoryState()
  const dispatch = useRosterCategoryDispatch()

  if (selectedCategory && selectedCategory !== "all") {
    const categoryRecord = publicCategories.find(
      ({ name }) => name === selectedCategory
    )

    const { subcategories } = categoryRecord

    return (
      <List>
        <li key={selectedCategory}>
          <RosterNavButton
            active
            onClick={() =>
              dispatch({
                type: rosterCategoryActions.SELECT_CATEGORY,
                payload: selectedCategory,
              })
            }
          >
            {selectedCategory}
          </RosterNavButton>
        </li>

        <SubcategoryButtons
          {...{
            subcategories: subcategories || [],
            selectedSubcategories,
            dispatch,
          }}
        />

        <AllButton dispatch={dispatch} />
      </List>
    )
  }

  return (
    <List>
      {publicCategories.map(category => (
        <li key={category.name}>
          <RosterNavButton
            onClick={() =>
              dispatch({
                type: rosterCategoryActions.SELECT_CATEGORY,
                payload: category.name,
              })
            }
          >
            {category.name}
          </RosterNavButton>
        </li>
      ))}

      <AllButton dispatch={dispatch} active />
    </List>
  )
}
